// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__2XAB7","rootUp":"Alert_rootUp__1GmIu","bg":"Alert_bg__1E7WH","bgUp":"Alert_bgUp__1UWhr","close":"Alert_close__QP5ZV"};